
export default function ExchangeRates() {
  const rates = [
    { currency: 'USD', name: 'الدولار الأمريكي', rate: '3.75', change: '+0.02' },
    { currency: 'EUR', name: 'اليورو', rate: '4.12', change: '-0.01' },
    { currency: 'GBP', name: 'الجنيه الإسترليني', rate: '4.85', change: '+0.05' },
    { currency: 'AED', name: 'الدرهم الإماراتي', rate: '1.02', change: '0.00' }
  ];

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-gray-800">أسعار الصرف</h3>
        <button className="text-blue-600 text-sm font-medium">
          عرض الكل
          <i className="ri-arrow-left-line mr-1"></i>
        </button>
      </div>
      
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        {rates.map((rate, index) => (
          <div key={rate.currency} className={`p-4 ${index !== rates.length - 1 ? 'border-b border-gray-100' : ''}`}>
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3 space-x-reverse">
                <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
                  <span className="text-sm font-bold text-gray-700">{rate.currency}</span>
                </div>
                <div>
                  <p className="font-medium text-gray-800">{rate.name}</p>
                  <p className="text-xs text-gray-600">مقابل الريال السعودي</p>
                </div>
              </div>
              
              <div className="text-left">
                <p className="font-bold text-gray-800">{rate.rate}</p>
                <p className={`text-xs ${
                  rate.change.startsWith('+') ? 'text-green-600' : 
                  rate.change.startsWith('-') ? 'text-red-600' : 'text-gray-600'
                }`}>
                  {rate.change}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
